import React from 'react';
import { Button, Box } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import GoogleIcon from '@mui/icons-material/Google';
import { blue, red, yellow, green } from '@mui/material/colors';

const styles = {
  googleButton: {
    background: `linear-gradient(135deg, ${blue[600]} 0%, ${red[600]} 25%,
    ${yellow[700]} 50%, ${green[600]} 75%, ${blue[600]} 100%)`,
    backgroundSize: '200% 200%',
    color: 'white',
    textTransform: 'none',
    padding: '10px 20px',
    transition: 'background-position 0.3s ease',
    '&:hover': {
      backgroundPosition: '100% 0',
    },
  },
  googleIcon: {
    marginRight: '10px',
  },
};

function GoogleLoginButton({ classes, disabled }) {
  const handleGoogleLogin = () => {
    window.location.href = `${window.location.origin}/api/auth/google`;
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
      <Button
        variant="contained"
        className={classes.googleButton}
        onClick={handleGoogleLogin}
        disabled={disabled}
        startIcon={<GoogleIcon className={classes.googleIcon} />}
      >
        Se connecter avec Google
      </Button>
    </Box>
  );
}

export default withStyles(GoogleLoginButton, styles);
